import { plans } from "./AllPlanTypes"

export const PostFilterOptions = [
    {
        group_label: "", 
        group_key: "viewType",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Seen',
                key: 'seen'
            },
            {
                label: 'Unseen',
                key: 'unseen'
            }
        ]
    },
    {
        group_label: "", 
        group_key: "containComment",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Contains comments',
                key: 'contains_comments'
            },
            {
                label: 'No comments',
                key: 'no_comments'
            }
        ]
    }
]

export const JobUpdatesDashboardFilterOptions = {
    teams_list:[
        { group_label: "", group_key: "teamType", options: plans },
    ],
    auto_sync_logs:[
        { group_label: "", group_key: "teamType", options: plans },
        { group_label: "", group_key: "syncState", options: [ { key: 'enqueue', label: 'Queued' }, { key: 'inprogress', label: 'InProgress' }, {key: 'incomplete', label: 'Incomplete' }, {key: 'shallow_completed', label: 'Shallow Completed' }, {key: 'detailed_inprogress', label: 'Detailed InProgress' }, { key: 'completed', label: 'Completed' }, { key: 'failed', label: 'Failed' }, { key: 'cancelled', label: 'Cancelled' } ] }
    ],
    rescan_logs:[
        { group_label: "", group_key: "teamType", options: plans },
        { group_label: "", group_key: "syncState", options: [ { key: 'shallow_completed', label: 'Shallow Completed' }, { key: 'detailed_inprogress', label: 'Detailed InProgress' }, { key: 'completed', label: 'Completed' }, { key: 'failed', label: 'Failed' } ] }
    ]
}

export const NewPostFilterOptions = [
    {
        group_label: "Comments", 
        group_key: "containComment",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Contains comments',
                key: 'contains_comments'
            },
            {
                label: 'No comments',
                key: 'no_comments'
            }
        ]
    },
    {
        group_label: "View", 
        group_key: "viewType",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Seen',
                key: 'seen'
            },
            {
                label: 'Unseen',
                key: 'unseen'
            }
        ]
    },
    {
        group_label: "Review", 
        group_key: "review",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Reviewed by',
                key: 'anyone',
                dynamic: true,
                filter_options: [{id: 'anyone', name: 'anyone', tooltipText: 'Reviewed by anyone\n(including you)'}, {id: 'me', name: 'me', tooltipText: 'Reviewed by you'}, {id: 'others', name: 'others', tooltipText: "Reviewed by anyone\nexcept you"}]
            },
            {
                label: 'Not reviewed',
                key: 'not_reviewed'
            },
        ]
    }
]

export const TempPostFilterOptions = [
    {
        group_label: "Suggestions", 
        group_key: "containSuggestion",
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Contains suggestions',
                key: 'contains_suggestions',
                value: true
            },
            {
                label: 'No suggestions',
                key: 'no_suggestions',
                value: false
            }
        ]
    }
]

export const PublishingFilterOptions = [
    {
        group_label: "Publishing", 
        group_key: "publishing",
        default_option: 'ready_to_publish',
        options: [
            {
                label: 'All',
                key: 'all'
            },
            {
                label: 'Ready to Publish',
                key: 'ready_to_publish'
            },
        ]
    }
]
